import { render, staticRenderFns } from "./AnalysisClinics.vue?vue&type=template&id=0f6588e6&scoped=true"
import script from "./AnalysisClinics.vue?vue&type=script&lang=js"
export * from "./AnalysisClinics.vue?vue&type=script&lang=js"
import style0 from "./AnalysisClinics.vue?vue&type=style&index=0&id=0f6588e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6588e6",
  null
  
)

export default component.exports